export const careersZh = {
  culture: {
    name: '企业文化及福利',
    value1: '全球创新',
    value2: '学思笃行',
    value3: '志在必得',
    value11: 'WORLD-CLASS INNOVATION',
    value22: 'LEARNING ORGANIZATION',
    value33: 'COMPETE TO WIN',
    intro: '在这里，我们以全球创新为驱动，倡导学思笃行的精神，与志在必得的专业人士共同塑造未来；我们不仅提供有竞争力的薪酬，更致力于打造一个让梦想家和实干家都能蓬勃发展的平台。',
    find_career: '加入我们'
  },
  learning: {
    name: '可持续的职业发展',
    intro: '迪哲医药坚持源头创新的理念，践行学无止境的核心价值观，打造学习型组织，注重人才培养及可持续发展。',
    detail: ['学习型组织文化 ', '个性化职业起步培训', '高管助力培养', '高潜领导力阶梯', '通用技能拓展']
  },
  healthSystem: {
    name: '全面健康体系',
    detail: [
      { name: '身心健康', detail: ['补充商业医疗保险', '年度全面体检', '员工援助项目（EAP）', '健身设施使用权'] },
      { name: '财务健康', detail: ['员工储蓄计划', '节日福利', '关爱商城专属权益'] },
      { name: '社交健康', detail: ['亲子活动', '公益项目', '多样化的员工活动', '迪哲志愿者服务机会'] },
      { name: '职业发展健康', detail: ['弹性工作制度', '多路径职业发展', '领导力发展项目', '新生代人才培养项目', '健全的合规体系与培训'] }
    ]
  },
  workplace: {
    name: '活力职场',
    desc: '迪哲医药从身体健康、心理健康、财富积累、社交拓展和职业发展等多维度出发，关怀每一位员工及其家庭，同时关注特殊人群和社会发展，致力于构建独具特色的职场文化，赢得业内持续赞誉。',
    type: ['员工文化', '办公场所'],
    detail1: [
      {
        title: '夏季运动的风吹到了“哲”儿！',
        href: 'https://mp.weixin.qq.com/s?__biz=MzUyMTkxNTY3Nw==&mid=2247486476&idx=1&sn=d8386cbec80fd921a738b325f2bf780f&chksm=f828b17a3d9206048bc6327618b77d5189f973c450a9ff2e3b5cd5556fc5c3ecb9fd7ad8bca5&sessionid=1725947690&scene=126&subscene=91&clicktime=1725947711&enterid=1725947711&ascene=3&fasttmpl_type=0&fasttmpl_fullversion=7376190-zh_CN-zip&fasttmpl_flag=0&realreporttime=1725947711101&devicetype=android-31&version=2800325a&nettype=cmnet&lang=zh_CN&session_us=gh_089b326f5145&countrycode=CN&exportkey=n_ChQIAhIQ9RnyPWxnlNfFMMmguSXoNRLdAQIE97dBBAEAAAAAAHHAEDx3ZAwAAAAOpnltbLcz9gKNyK89dVj0UzwpUOcGitpUvl167YfWrmc7nivfcCfxKik%2BLm6t8M83czIoPZ5ejhwYlG3Sv4CvBL%2F7kOVTsZfJbyB6NzGjST4cXssx3Rwnan065IonfEYhsQlc3cpBqJC754QpPlX%2BaQB14CzLo3BMQq36KJx9UwQUx8X9gFzaFZ%2B1%2FfDIZ4H4%2FRe4ZW%2Bbh0KaRCa9BOe5li329hf%2FDEaEOpOxZbduqzfcRFA%2BKY%2FwzGqn5JPi9kbEaagMhiuJ&pass_ticket=lmznTmuNUCroEfpsRPKGcbywi%2FkU3Gn7It%2BDvCCPBG%2B9o%2Bxp9JBMQVjJhcK%2BeFk6&wx_header=3'
      },
      {
        title: '“迪”久天长，共赴可持续发展的未来！',
        href: 'https://mp.weixin.qq.com/s?__biz=MzUyMTkxNTY3Nw==&mid=2247486362&idx=1&sn=8b8fecfab45999810f4046e4f23ca9d4&chksm=f848261341a55fb64416783b8bcd452056c29921beea5aa8c6da3566bb08cc87da97866506a0&sessionid=1725947690&scene=126&subscene=91&clicktime=1725947741&enterid=1725947741&ascene=3&fasttmpl_type=0&fasttmpl_fullversion=7376190-zh_CN-zip&fasttmpl_flag=0&realreporttime=1725947741135&devicetype=android-31&version=2800325a&nettype=cmnet&lang=zh_CN&session_us=gh_089b326f5145&countrycode=CN&exportkey=n_ChQIAhIQ%2Bp2O0%2FoZozkpxRVk%2BMPfdhLtAQIE97dBBAEAAAAAANysIwsc45wAAAAOpnltbLcz9gKNyK89dVj0CLodktx1W0xoexTLAWdTnbCw%2BCFYbAI5V6wvd%2FuyK%2FvBFsueWK1kdAnEBJeRZtfrdt65N9sv%2FqImILgXtLMuT2UMcNhMXL4akJ4iWaZkn5g0VKGLBWUGX8mtWK70zX8uZfv081tKJkM5Ru%2F3X%2BRV6S%2F21dvs8UDTlt12mGfjz6s4LZdOORYGeUYIRqp6CZConkSUvZdoC6lU2Szcvs%2FQfvbHtB26nEJeZp3yADawBfvg8KN1zNuFr8kwShdz%2Fs2Yl9lgk4eueQ%3D%3D&pass_ticket=c1s%2FM6tBkWwChzLQixzYdc0BPYPkzhmjOozrYytFU23oLDnPiApwQH7koJ8L30ou&wx_header=3'
      },
      {
        title: '2023硕果累累，2024启程新旅！',
        href: 'https://mp.weixin.qq.com/s?__biz=MzUyMTkxNTY3Nw==&mid=2247486309&idx=1&sn=be32751eaa5e84f1939f98c9bd152d91&chksm=f8f6a064c5a716a63ea1bca39e7b46154f4f9db82a9c4d8127e6e0eb9430d0fd0f68861bfd90&sessionid=0&scene=126&clicktime=1712737097&enterid=1712737097&subscene=10000&ascene=3&fasttmpl_type=0&fasttmpl_fullversion=7155869-zh_CN-zip&fasttmpl_flag=0&realreporttime=1712737097488&devicetype=android-31&version=4.1.22.6012&nettype=WIFI&abtest_cookie=AAACAA%3D%3D&lang=zh_CN&session_us=gh_089b326f5145&countrycode=CN&exportkey=n_ChQIAhIQsScplb%2B5EDCI84r%2FrxgFpRLrAQIE97dBBAEAAAAAAByqFWMiCFkAAAAOpnltbLcz9gKNyK89dVj0BF9hevpwjkSO8NPi6J8eAUPYDsxX1hDxmivlq3IZ5bT%2B2FVpC1phR9He1Z0TCFfGyvvSL6CziuFax4OC4e4H%2BlNN7%2FM9%2B0nhzSOrD3irJ0e6t4PT76Mr1RXL%2FuXCMoNYu%2B8JcqoZqFnqLEj3y3YCcM8s3UPqKdhuVV8%2BzEjJ%2FCM8lTVTbbwZlCyp8O%2Bpoydvjp7oG2ZidvqrdxslXg3K9h3TdIF5mdNKIXuizuQyJTIfUCN6br1dg6U5HktCiVUK7MJEEfY%3D&pass_ticket=3H%2F07hywele9hOX35HtBpUdKwa6yU1697ZnW0ZTSlt9ILWNkexFKvp4i%2Fu6GZKdHRsyCkxAdPtALF6HqGDyeFg%3D%3D&wx_header=3&platform=win'
      },
      {
        title: '“铁三”赛载誉而归|迪哲医药，最健康雇主的激情与活力',
        href: 'https://mp.weixin.qq.com/s?__biz=MzUyMTkxNTY3Nw==&mid=2247485844&idx=1&sn=d842fcea45a5f47d16254cadb12359ca&chksm=f8a4e9bbed3203d47624c01e2e89b6b7ce3af9c986bfe413d5a447833c41f8e1a9988f28b2d3&sessionid=0&scene=126&clicktime=1712737187&enterid=1712737187&subscene=10000&ascene=3&fasttmpl_type=0&fasttmpl_fullversion=7155869-zh_CN-zip&fasttmpl_flag=0&realreporttime=1712737187647&devicetype=android-31&version=4.1.22.6012&nettype=WIFI&abtest_cookie=AAACAA%3D%3D&lang=zh_CN&session_us=gh_089b326f5145&countrycode=CN&exportkey=n_ChQIAhIQU7Jf2B%2BR0fPmXkmsRlOk8RLbAQIE97dBBAEAAAAAAIgVGaIfWGQAAAAOpnltbLcz9gKNyK89dVj07Eh7PUFe3TF4jmDVtK8goG80uH5hjWa9tlpVJUXF%2FQUIVqPLTxm5v7WimERuSi2INeRf3w2Xfe%2FAHahzlHhuWPWEdRtTd0b9%2FCnphhT%2FjtgCacrDstaqen4NLqcoIVHlAY%2Fg3r73Zl0hD320Dmm9jmaNULKMHqe1HEyHeAjjpL%2B8FfhEZnHsMa%2BhlejzsV5D0a8xwpH88caHKZEX3Jey6WbRG4Pbpe2r86nX7E924KdASOnqcg%3D%3D&pass_ticket=3H%2F07hywele9hOX35HtBpUdKwa6yU1697ZnW0ZTSlt%2F9L%2F8aiKAdyTxB1Gwyq0y1svwwklTy3yUOmp8BeVCmMQ%3D%3D&wx_header=3&platform=win'
      },
      {
        title: '「闪耀Z计划」，打动这届年轻人！',
        href: 'https://mp.weixin.qq.com/s?__biz=MzUyMTkxNTY3Nw==&mid=2247485822&idx=1&sn=a17d10e4ab7eb375525aa062b76e18ed&chksm=f8e40457e2aa395baaa3ae606c1246f39d894bf3051ec146782b747fa33a470db9e6dbc0f477&sessionid=0&scene=126&clicktime=1712737272&enterid=1712737272&subscene=10000&ascene=3&fasttmpl_type=0&fasttmpl_fullversion=7155869-zh_CN-zip&fasttmpl_flag=0&realreporttime=1712737272436&devicetype=android-31&version=4.1.22.6012&nettype=WIFI&abtest_cookie=AAACAA%3D%3D&lang=zh_CN&session_us=gh_089b326f5145&countrycode=CN&exportkey=n_ChQIAhIQmrHONUFwQqPu4%2FOIFuSkFhLrAQIE97dBBAEAAAAAADnBNZfKQjsAAAAOpnltbLcz9gKNyK89dVj0P2K70S9ZrFs8%2BeMo0mMc%2BaZHjCEi2MgpMOZndALk3IW%2FrT2FyrXViiYBQ0aZkzraKTDXTUQ1xrxn5csva1zj7sH3mf23xczVcChcqwdFoGyf5GezoSSY0awzu40GvIWjXa861I7E9i2G2rtXS6qQoV2cWt%2F5BFEnJbEDDL%2BUnGdQ8Z4%2BxOkOGOGYmdj9FHgX1fsme9aHILCksyn2rTx%2FTUHVcFHv4nrJWHXBqq9XHxg%2B3aFfBClR%2FQxKjKDvv8KqQWDn5Sw%3D&pass_ticket=3H%2F07hywele9hOX35HtBpUdKwa6yU1697ZnW0ZTSlt8dscA1UiQowr5GnlBIWbKOKJViPg8NdCoDjZkn1lCqcg%3D%3D&wx_header=3&platform=win'
      },
      {
        title: '安全文化示范企业热招岗位 | “哲”是最安全的职场',
        href: 'https://mp.weixin.qq.com/s?__biz=MzUyMTkxNTY3Nw==&mid=2247485618&idx=1&sn=87797f16d7f2a5c7a3dca74b9c40ee3e&chksm=f887129777cf186165a84c553160e8a7e3a33baf591724f14eebd3d38c022e82467f7302f8db&sessionid=0&scene=126&clicktime=1712737207&enterid=1712737207&subscene=10000&ascene=3&fasttmpl_type=0&fasttmpl_fullversion=7155869-zh_CN-zip&fasttmpl_flag=0&realreporttime=1712737208000&devicetype=android-31&version=4.1.22.6012&nettype=WIFI&abtest_cookie=AAACAA%3D%3D&lang=zh_CN&session_us=gh_089b326f5145&countrycode=CN&exportkey=n_ChQIAhIQ99QeQ4wNWQjBsZ6TKjLwKBLrAQIE97dBBAEAAAAAAFPgKVlJCvwAAAAOpnltbLcz9gKNyK89dVj09NfaZdTp1dSYKqrgaeTJJaoAjNYnfWRqBbiPbYZ%2BbkdhDDilCkAL%2BR7mVozeqYP2r4PXinXbtSU3F34FOuEIA0fuLUusvYb54nK2t%2BIVxkTzhlyeTtZRtDy%2BEt7%2BHGXOHeCA1vrNw%2BqxngdSjVKeGYkDQHxZX%2BFM%2FJVZiXvG6KHA7wnmm60gj%2F94fQie009HcVOMFd%2Bc87ve7%2BuDMjOntqsT4Emy90e7yvrmuQcnsTinT5dud%2BQn%2FoV2MIZJXgtTMDa0ARU%3D&pass_ticket=3H%2F07hywele9hOX35HtBpUdKwa6yU1697ZnW0ZTSlt8%2BSz%2B3v2MeogXvg%2B6c7EognEhVr%2B8nnfxijp3XoNPnKQ%3D%3D&wx_header=3&platform=win'
      }
    ],
    detail2: [
      {
        title: '上海亮景路办公室',
        img: 'liangjing.JPG',
        href: 'https://www.dizalpharma.com/contact/map?city=Shanghai'
      },
      {
        title: '上海祖园办公室',
        img: 'zuyuan.JPG',
        href: 'https://www.dizalpharma.com/contact/map?city=Shanghai'
      },
      {
        title: '上海李冰路办公室',
        img: 'libing.JPG',
        href: 'https://www.dizalpharma.com/contact/map?city=Shanghai'
      },
      {
        title: '北京办公室',
        img: 'beijing.JPG',
        href: 'https://www.dizalpharma.com/contact/map?city=Beijing'
      },
      {
        title: '成都办公室',
        img: 'chengdu.JPG',
        href: 'https://www.dizalpharma.com/contact/map?city=Chengdu'
      },
      {
        title: '无锡办公室',
        img: 'wuxi.JPG',
        href: 'https://www.dizalpharma.com/contact/map?city=Wuxi'
      }
    ]
  },
  award: {
    name: '荣誉奖项',
    awardList: [
      {
        title: '2024 杰出雇主',
        desc: '荣膺“2024人力资源管理卓越大奖” - “杰出雇主”'
      },
      {
        title: '2024 亚洲最佳职场',
        desc: '荣膺“2024亚洲最佳职场（中国大陆区）奖项” - “最佳职场奖”'
      },
      {
        title: '2023 最适宜工作的职场',
        desc: '荣膺“浦东国际人才港论坛” - “2023最适宜工作的职场”'
      },
      {
        title: '2023 杰出雇主',
        desc: '荣膺“2023人力资源管理卓越大奖” - “杰出雇主”'
      },
      {
        title: '2023 最佳新员工融入奖',
        desc: '荣膺“2023智享会招聘与任用价值大奖” - “最佳新员工融入奖”'
      },
      {
        title: '2022 大中华区杰出雇主奖',
        desc: '荣膺“2022HRoot大中华区人力资源管理卓越大奖” - “大中华区杰出雇主奖”'
      },
      {
        title: '2021 亚洲最佳职场',
        desc: '蝉联“2021亚洲最佳职场（中国大陆区）奖项评选” - “最健康雇主奖”'
      },
      {
        title: '2020 怡安臻选最佳员工健康雇主',
        desc: '荣膺“2020怡安臻选最佳员工健康雇主” - “最佳心理健康实践奖”'
      },
      {
        title: '2019 亚洲最佳职场',
        desc: '荣膺“2019亚洲最佳职场(中国大陆区)奖项评选” - “最健康员工奖”'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/lang/careers-zh.js